import { Nav } from "./Nav";
import { Footer } from "./Footer";
import { Toaster } from "../ui/sonner";

export const PageShell = ({ children, testId }) => (
  <div data-testid={testId} className="relative min-h-screen bg-tria-ink font-body text-white">
    <div className="noise-overlay" />
    <Nav />
    <main>{children}</main>
    <Footer />
    <Toaster
      theme="dark"
      position="top-center"
      richColors
      toastOptions={{ style: { background: "#0A1526", border: "1px solid rgba(125,211,252,0.25)", color: "#fff" } }}
    />
  </div>
);
